import React, { useState } from 'react';
import './Header.css';
import Search from '../Search/Search';
import BarSup from '../BarSup/BarSup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import ProviderMenu from '../ProviderMenu/ProviderMenu';
import { useNavigate } from 'react-router-dom';

const Header = ({ minimal = false, searchBar = false, menuProvider = false, providerName = '', providerBanner, providerLogo,currentPage = '', backOn = false, isHome = false }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    const handleBack = () => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            navigate('/');
        }
    };

    if (searchBar) {
        return (
            <header className={backOn ? "header search-bar" : "header search-bar logo"}>
                <div className={backOn ? "back-button-header only" : "back-button-header"} onClick={handleBack}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                    {backOn && (
                        <img onClick={() => window.location.href = "/"} src="/logo.webp" alt="Logo" className="logo-minymol" />
                    )}
                </div>
                {!backOn && (
                    <div className='logo-provider'>
                        <img src={providerBanner || '/logoSup.webp'} alt="Logo" />
                    </div>
                )}
            </header>
        );
    }

    return (
        <header className={minimal ? "header minimal" : "header"} style={{ position: 'relative' }}>
            <div className='buttons'>
                {menuProvider && (
                    <ProviderMenu
                        providerName={providerName}
                        isOpen={menuOpen}
                        toggleMenu={setMenuOpen}
                        currentPage={currentPage}
                        providerLogo={providerLogo}
                    />
                )}
                {(minimal || menuProvider) && (
                    <img onClick={() => window.location.href = "/"} src="/logo.webp" alt="Logo" className="logo-minymol" />
                )}
            </div>

            {!minimal && (
                <>
                    <div className='title-header'>
                        {!isHome && (
                            <div className='back-btn-header' onClick={handleBack}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </div>
                        )}
                        <img onClick={() => window.location.href = "/"} src="/logo.webp" alt="Logo" className="logo-minymol" />
                        <Search />
                    </div>
                    <BarSup />
                </>
            )}
        </header>
    );
};

export default Header;
